import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: 'いつから使えますか？',
      answer: 'Ver.0は2026/3/27予定です。開始案内はLINEで送ります。'
    },
    {
      question: '登録に費用はかかりますか？',
      answer: '完全無料です。LINE友だち追加だけで登録完了します。'
    },
    {
      question: '個人情報は必要ですか？',
      answer: 'LINE IDのみで利用可能です。追加の個人情報は不要です。'
    },
    {
      question: '料金はかかりますか？',
      answer: 'Ver.0は無料予定です。変更がある場合は事前にLINEで告知します。'
    },
    {
      question: '通知が多い？',
      answer: '必要な案内だけにします。止めたい場合はブロックでOKです。'
    },
    {
      question: 'どんな動画を投稿すればいい？',
      answer: '迷ったらこの型：料理の完成形 → 店内 → 外観/看板（10秒前後目安）。詳細はLINEで案内します。'
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-20 bg-[#F8F8F8]">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Title */}
        <h2 className="text-4xl font-bold text-center text-[#111111] mb-16">
          FAQ
        </h2>

        {/* FAQ Items */}
        <div className="space-y-4 mb-12">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-xl overflow-hidden transition-all duration-300"
              style={{ boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}
            >
              {/* Question */}
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between p-6 text-left hover:bg-gray-50 transition-colors cursor-pointer"
              >
                <div className="flex items-center flex-1">
                  <div className="w-8 h-8 bg-[#EDD92A] rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                    <span className="text-sm font-bold text-black">Q</span>
                  </div>
                  <span className="text-lg font-bold text-[#111111]">{faq.question}</span>
                </div>
                <i
                  className={`ri-arrow-${openIndex === index ? 'up' : 'down'}-s-line text-2xl text-gray-600 transition-transform duration-300 ml-4`}
                ></i>
              </button>

              {/* Answer */}
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-6 pb-6 border-t border-gray-200">
                  <div className="flex items-start pt-4">
                    <div className="w-8 h-8 bg-gray-300 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                      <span className="text-sm font-bold text-white">A</span>
                    </div>
                    <p className="text-base text-gray-700 leading-relaxed flex-1">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Section CTA */}
        <div className="text-center">
          <a
            href="https://lin.ee/PJ9odjt"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-[#EDD92A] text-black font-bold px-8 py-4 rounded-2xl hover:shadow-xl transition-all duration-300 hover:-translate-y-1 whitespace-nowrap cursor-pointer"
            style={{ boxShadow: '0 6px 16px rgba(0,0,0,0.15)' }}
          >
            LINEで先行テスター/投稿者登録（無料）
          </a>
        </div>
      </div>
    </section>
  );
}
